// 班级报告 R1 预览样例（/print/class/preview 用）。
// 与后端 build_class_report_payload 形态一致：cover/dashboard/heatmap/risks/recommendation。
// 5 力真实 code（ai_leverage/ai_symbiosis/ai_team_leadership/ai_governance/ai_strategic_foresight）。
// 无 trait_distribution、无 response_quality（已去素质 / 去作答质量）。

const DIMS = [
  { code: 'ai_leverage', name: 'AI 借力', sort_order: 1 },
  { code: 'ai_symbiosis', name: 'AI 共生', sort_order: 2 },
  { code: 'ai_team_leadership', name: 'AI 带队', sort_order: 3 },
  { code: 'ai_governance', name: 'AI 治理', sort_order: 4 },
  { code: 'ai_strategic_foresight', name: 'AI 谋势', sort_order: 5 },
];

const DIM_AVGS = [
  { ...DIMS[0], avg_score: 78, industry_baseline: null, affected_count: 1 },
  { ...DIMS[1], avg_score: 71, industry_baseline: null, affected_count: 2 },
  { ...DIMS[2], avg_score: 58, industry_baseline: null, affected_count: 5 },
  { ...DIMS[3], avg_score: 49, industry_baseline: null, affected_count: 7 },
  { ...DIMS[4], avg_score: 63, industry_baseline: null, affected_count: 3 },
];

const LAYER_DISTRIBUTION = [
  { l_grade: 'L1', count: 2, pct: 16.7 },
  { l_grade: 'L2', count: 5, pct: 41.7 },
  { l_grade: 'L3', count: 4, pct: 33.3 },
  { l_grade: 'L4', count: 1, pct: 8.3 },
];

const SCORE_DISTRIBUTION = [
  { range: '0-9', count: 0 }, { range: '10-19', count: 0 }, { range: '20-29', count: 0 },
  { range: '30-39', count: 0 }, { range: '40-49', count: 1 }, { range: '50-59', count: 2 },
  { range: '60-69', count: 4 }, { range: '70-79', count: 3 }, { range: '80-89', count: 2 },
  { range: '90-99', count: 0 }, { range: '100', count: 0 },
];

function row(id, name, position, scores) {
  return { student: { id, display_name: name, position }, total_score: Math.round(scores.reduce((a, b) => a + b, 0) / scores.length), scores };
}

export const mockClassReportPayload = {
  scope: 'class',
  cover: {
    enterprise_name: '前哨科技',
    class_name: '2026 春季一班',
    team_avg_score: 64.5,
    layer_distribution: LAYER_DISTRIBUTION,
    report_date: '2026-06-10',
  },
  dashboard: {
    completion: { total: 12, completed: 10, in_progress: 1, not_started: 1 },
    team_avg_score: 64.5,
    dimension_avgs: DIM_AVGS,
    score_distribution: SCORE_DISTRIBUTION,
    layer_distribution: LAYER_DISTRIBUTION,
    position_top5: [
      { position: '产品经理', count: 4 },
      { position: '研发工程师', count: 3 },
      { position: '运营', count: 2 },
      { position: '设计', count: 1 },
    ],
    cache: { hit: false, generated_at: '2026-06-10T02:00:00' },
  },
  heatmap: {
    dimensions: DIMS,
    rows: [
      row(1, '张三', '产品经理', [85, 78, 62, 55, 70]),
      row(2, '李四', '研发工程师', [72, 68, 50, 44, 60]),
      row(3, '王五', '运营', [60, 55, 48, 40, 52]),
    ],
    overflow: { count: 7, team_avg: 63.2 },
  },
  risks: {
    summary: {
      counts_by_level: { 极高: 1, 高: 3, 中: 5, 低: 2 },
      top_risk_dims: [
        { dim_code: 'ai_governance', dim_name: 'AI 治理', affected: 7, total: 10 },
        { dim_code: 'ai_team_leadership', dim_name: 'AI 带队', affected: 5, total: 10 },
      ],
      generated_at: '2026-06-10T02:00:00',
      cache_hit: false,
    },
    items: [
      { student: { id: 3, display_name: '王五', position: '运营' }, dim_code: 'ai_governance', dim_name: 'AI 治理', score: 40, threshold: 60, level: '极高', text: '王五 在 AI 治理 维度 40 分，低于阈值 60，建议优先关注合规与风险意识。' },
      { student: { id: 2, display_name: '李四', position: '研发工程师' }, dim_code: 'ai_governance', dim_name: 'AI 治理', score: 44, threshold: 60, level: '高', text: '李四 在 AI 治理 维度偏弱，建议补充治理实践训练。' },
    ],
    items_overflow: 0,
  },
  recommendation: {
    generated_at: '2026-06-10T02:00:00',
    class_headline_tag: '治理短板突出、借力能力领先的成长型团队',
    class_summary: '本班整体处于 L2-L3 过渡阶段，AI 借力能力突出，但 AI 治理与带队维度存在系统性短板，建议以治理为先导开展针对性训练，带动团队整体跃迁。',
    team_weakness: [
      { dim_code: 'ai_governance', dim_name: 'AI 治理', avg_score: 49, affected_count: 7 },
      { dim_code: 'ai_team_leadership', dim_name: 'AI 带队', avg_score: 58, affected_count: 5 },
    ],
    focus_dims: [],
    is_relative_focus: false,
    recommendations: [
      {
        title: 'AI 治理能力专项提升',
        priority: 'P0',
        affected_count: 7,
        target_dims: ['ai_governance'],
        why_priority: '7 人低于阈值，是团队最突出的系统性短板，直接影响合规与风险防控。',
        improvement_directions: ['建立 AI 使用合规清单', '识别数据与隐私风险', '输出可审计的决策记录'],
        observable_behaviors: '能在使用 AI 前主动评估风险并留痕。',
        if_skipped_risks: '合规事故与数据泄露风险上升。',
        cross_dim_links: ['ai_strategic_foresight'],
      },
      {
        title: 'AI 带队协同训练',
        priority: 'P1',
        affected_count: 5,
        target_dims: ['ai_team_leadership'],
        why_priority: '5 人偏低，影响团队级 AI 协同效率。',
        improvement_directions: ['制定团队 AI 协作规范', '复盘 AI 协同案例'],
        observable_behaviors: '能组织团队共享与复用 AI 工作流。',
        if_skipped_risks: '团队 AI 应用各自为政，难以规模化。',
        cross_dim_links: [],
      },
    ],
    layer_distribution: LAYER_DISTRIBUTION,
    position_top5: [],
    ai_meta: { model: 'mock', prompt_version: 1 },
  },
};

export default mockClassReportPayload;
